import { createSlice } from '@reduxjs/toolkit'


const initialState = {
  token: null,
  loading: false
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action) => ({...state, ...action.payload}),
    setLoading: (state, action) => ({...state, loading: action.payload}),
    clearAuth: () => ({...initialState})
  }
})

export const { setAuth, clearAuth, setLoading } = authSlice.actions
export default authSlice.reducer
